// Dates and times picked, not typed (Adam, 4 Oct, answer 8): the browser's own date picker, which on a
// phone is the phone's, with the date written out under it as the boards write dates; a day of the
// week; and a time from a list in the boards' form (7pm, 7:30pm).
//
//   <DateField label="Until" value={until} onChange={setUntil} min={todayInUk()} />   value 'YYYY-MM-DD'
//   <DayField label="Day" value={day} onChange={setDay} />                          value 0 (Sunday) to 6
//   <TimeField label="Time, UK" value={at} onChange={setAt} />                      value 'HH:MM', 24-hour
//
// A date picked is a London day. For a write that needs a moment, ukEndOfDay(day) (access runs to the
// end of it) or ukToIso(day, 'HH:MM') from ui/format.js; the stage 5 functions take ends_on and
// until_on as the day itself.
import { Field, Select } from './Form.jsx'
import { ukDateLong, time } from './format.js'

export function DateField({ label, value, onChange, min, max, hint, error, plain, required, disabled, className }) {
  const words = value ? ukDateLong(value) : ''
  return (
    <Field label={label} hint={[words, hint].filter(Boolean).join('. ') || undefined} error={error} plain={plain} className={className}>
      {props => (
        <input type="date" className="ad-input" value={value || ''} min={min} max={max} required={required} disabled={disabled}
          onChange={e => onChange?.(e.target.value)} {...props} />
      )}
    </Field>
  )
}

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
// Monday first, as a week is written in the UK
const DAY_ORDER = [1, 2, 3, 4, 5, 6, 0]
export function DayField({ label, value, onChange, hint, error, plain, placeholder = 'Pick a day' }) {
  return (
    <Field label={label} hint={hint} error={error} plain={plain}>
      {props => (
        <Select value={value === null || value === undefined ? '' : String(value)} placeholder={placeholder}
          onChange={v => onChange?.(v === '' ? null : Number(v))}
          options={DAY_ORDER.map(d => ({ value: String(d), label: DAY_NAMES[d] }))} {...props} />
      )}
    </Field>
  )
}

// Every quarter of an hour from 6am to 10:45pm, unless from, to and step say otherwise (minutes)
export function timeOptions({ from = 6 * 60, to = 22 * 60 + 45, step = 15 } = {}) {
  const out = []
  for (let m = from; m <= to; m += step) {
    const hh = Math.floor(m / 60), mm = m % 60
    const value = `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
    out.push({ value, label: time({ hh, mm, day: 0 }) })
  }
  return out
}

export function TimeField({ label, value, onChange, hint, error, plain, placeholder = 'Pick a time', from, to, step, className }) {
  const options = timeOptions({ from, to, step })
  // a saved time that isn't on the list (7:10pm) still shows as itself
  if (value && !options.some(o => o.value === value)) {
    const [hh, mm] = value.split(':').map(Number)
    options.push({ value, label: time({ hh, mm, day: 0 }) })
    options.sort((a, b) => a.value.localeCompare(b.value))
  }
  return (
    <Field label={label} hint={hint} error={error} plain={plain} className={className}>
      {props => <Select value={value || ''} placeholder={placeholder} onChange={v => onChange?.(v || null)} options={options} {...props} />}
    </Field>
  )
}
